export interface PoolParticipant {
  id: string;
  name: string;
  email: string;
  phone: string;
  shares: number;
}

export const canonicalParticipants = (rows: PoolParticipant[]) => [...rows].sort((a, b) => a.id.localeCompare(b.id));
export const participantTotals = (rows: PoolParticipant[], cost: number) => {
  const shares = rows.reduce((sum, row) => sum + row.shares, 0);
  return { shares, perShare: shares > 0 ? cost / shares : 0 };
};
export function validateParticipant(row: PoolParticipant): string | undefined {
  if (!row.name.trim() || row.name.trim().length > 120) return "Informe um nome válido";
  if (row.email && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email) || row.email.length > 320)) return "Informe um e-mail válido";
  if (!Number.isInteger(row.shares) || row.shares < 1 || row.shares > 100000) return "Informe uma quantidade válida de cotas";
  if (row.phone.length > 30) return "Informe um celular válido";
}